import { produce } from 'immer'
import {
  GET_ORGANIZATION_MEMBERS_FAILURE,
  GET_ORGANIZATION_MEMBERS_INIT,
  GET_ORGANIZATION_MEMBERS_SUCCESS,
  GetRequestVirtualCardMembersActions,
} from 'src/app/RequestVirtualCard/redux/requestVirtualCard.actions'
import { GET_ME_SUCCESS, GetMeActions } from 'src/redux/actions/auth.actions'
import {
  GET_USER_SUCCESS,
  GET_USERS_FAILURE,
  GET_USERS_INIT,
  GET_USERS_SUCCESS,
  GetUserActions,
  GetUsersActions,
} from 'src/redux/actions/data/users.actions'

export interface UsersFullPaginatedDataState {
  ids: string[]
  loading: boolean
  complete: boolean
  page?: number
  numPages?: number
  totalItems?: number
}

export const initialState: UsersFullPaginatedDataState = {
  ids: [],
  loading: false,
  complete: false,
}

export type Actions =
  | GetUsersActions
  | GetUserActions
  | GetMeActions
  | GetRequestVirtualCardMembersActions

export const UsersFullPaginatedDataReducer = (
  state = initialState,
  action: Actions,
): UsersFullPaginatedDataState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_ORGANIZATION_MEMBERS_INIT:
      case GET_USERS_INIT: {
        draft.loading = true
        return draft
      }

      case GET_ORGANIZATION_MEMBERS_SUCCESS:
      case GET_USERS_SUCCESS: {
        draft.loading = false
        draft.ids =
          action.payload.pagination.page === 0
            ? action.payload.users.map((user) => user.id)
            : [...draft.ids, ...action.payload.users.map((user) => user.id)]
        draft.complete =
          action.payload.pagination.page >=
          action.payload.pagination.numberOfPages - 1
        draft.page = action.payload.pagination.page
        draft.numPages = action.payload.pagination.numberOfPages
        draft.totalItems = action.payload.pagination.totalItems
        return draft
      }

      case GET_ORGANIZATION_MEMBERS_FAILURE:
      case GET_USERS_FAILURE: {
        draft.loading = false
        draft.complete = true
        return draft
      }

      case GET_USER_SUCCESS:
      case GET_ME_SUCCESS: {
        draft.ids = draft.ids.includes(action.payload.id)
          ? draft.ids
          : [action.payload.id, ...draft.ids]
        return draft
      }
    }
  })
}

export default UsersFullPaginatedDataReducer
